"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScreenReaderContent = exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeable = require("@instructure/ui-themeable/lib/themeable.js");

var _passthroughProps = require("@instructure/ui-react-utils/lib/passthroughProps.js");

var _getElementType = require("@instructure/ui-react-utils/lib/getElementType.js");

var _dec, _class, _class2, _temp;

var styles = {
  componentId: 'ergWt',
  template: function template(theme) {
    return "\n\n.ergWt_bGBk{border:0;clip:rect(0 0 0 0);height:0.0625rem;inset-inline-start:0;margin:-0.0625rem;overflow:hidden;padding:0;position:absolute;top:0;width:0.0625rem}\n\n[dir=ltr] .ergWt_bGBk{left:0}\n\n[dir=rtl] .ergWt_bGBk{right:0}";
  },
  'root': 'ergWt_bGBk'
};
/**
---
category: components/utilities
---
@module ScreenReaderContent
**/

var ScreenReaderContent = (_dec = (0, _themeable.themeable)(null, styles), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ScreenReaderContent, _Component);

  var _super = (0, _createSuper2.default)(ScreenReaderContent);

  function ScreenReaderContent() {
    (0, _classCallCheck2.default)(this, ScreenReaderContent);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ScreenReaderContent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["children"]);
      var ElementType = (0, _getElementType.getElementType)(ScreenReaderContent, props);
      return /*#__PURE__*/_react.default.createElement(ElementType, Object.assign({}, (0, _passthroughProps.passthroughProps)(props), {
        className: styles.root
      }), children);
    }
  }]);
  ScreenReaderContent.displayName = "ScreenReaderContent";
  return ScreenReaderContent;
}(_react.Component), _class2.propTypes = {
  /**
  * the element type to render as
  */
  as: _propTypes.default.elementType,

  /**
  * content meant for screen readers only
  */
  children: _propTypes.default.node
}, _class2.defaultProps = {
  as: 'span',
  children: null
}, _temp)) || _class);
exports.ScreenReaderContent = ScreenReaderContent;
var _default = ScreenReaderContent;
exports.default = _default;